import React, { useState, useEffect, useRef } from 'react';

const S = {
  overlay: {
    position: 'fixed',
    inset: 0,
    background: 'rgba(15,23,42,0.45)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1000,
  },
  modal: {
    background: '#ffffff',
    border: '1px solid #dbe4ef',
    borderRadius: 12,
    width: 380,
    maxWidth: 'calc(100vw - 32px)',
    boxShadow: '0 20px 60px rgba(0,0,0,0.18)',
    overflow: 'hidden',
  },
  header: {
    padding: '18px 24px 0',
    display: 'flex',
    alignItems: 'center',
    gap: 10,
  },
  icone: {
    width: 36,
    height: 36,
    borderRadius: 8,
    background: '#fffbeb',
    border: '1px solid #fcd34d',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 18,
    flexShrink: 0,
  },
  titulo: {
    fontSize: 16,
    fontWeight: 700,
    color: '#0f172a',
  },
  corpo: {
    padding: '14px 24px 24px',
  },
  descricao: {
    fontSize: 13,
    color: '#64748b',
    marginBottom: 16,
    lineHeight: 1.5,
  },
  label: {
    display: 'block',
    fontSize: 12,
    fontWeight: 600,
    color: '#334155',
    marginBottom: 6,
  },
  input: {
    width: '100%',
    padding: '10px 12px',
    fontSize: 14,
    background: '#ffffff',
    color: '#0f172a',
    border: '1px solid #cbd5e1',
    borderRadius: 8,
    outline: 'none',
    boxSizing: 'border-box',
    transition: 'border-color 0.15s',
  },
  inputErro: {
    borderColor: '#ef4444',
  },
  mensagemErro: {
    fontSize: 12,
    color: '#ef4444',
    marginTop: 6,
    display: 'flex',
    alignItems: 'center',
    gap: 4,
  },
  acoes: {
    display: 'flex',
    gap: 8,
    marginTop: 20,
  },
  btnCancelar: {
    flex: 1,
    padding: '10px 0',
    background: 'transparent',
    color: '#334155',
    border: '1px solid #cbd5e1',
    borderRadius: 8,
    fontSize: 13,
    fontWeight: 500,
    cursor: 'pointer',
  },
  btnConfirmar: {
    flex: 1,
    padding: '10px 0',
    background: '#3b82f6',
    color: '#ffffff',
    border: 'none',
    borderRadius: 8,
    fontSize: 13,
    fontWeight: 600,
    cursor: 'pointer',
  },
  btnConfirmarDesabilitado: {
    flex: 1,
    padding: '10px 0',
    background: '#93c5fd',
    color: '#1e293b',
    border: 'none',
    borderRadius: 8,
    fontSize: 13,
    fontWeight: 600,
    cursor: 'not-allowed',
  },
};

export default function ModalSenhaDeploy({ nomeProjeto, erroExterno, onConfirmar, onCancelar }) {
  const [senha, setSenha] = useState('');
  const [inputLiberado, setInputLiberado] = useState(false);
  const inputRef = useRef(null);

  useEffect(() => {
    const timer = setTimeout(() => {
      setInputLiberado(true);
      if (inputRef.current) inputRef.current.focus();
    }, 50);

    return () => clearTimeout(timer);
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!senha) return;
    onConfirmar(senha);
  };

  const temErro = !!erroExterno;

  return (
    <div style={S.overlay} onClick={(e) => { if (e.target === e.currentTarget) onCancelar(); }}>
      <div style={S.modal}>
        <div style={S.header}>
          <div style={S.icone}>🔒</div>
          <span style={S.titulo}>Deploy protegido</span>
        </div>
        <div style={S.corpo}>
          <p style={S.descricao}>
            O projeto <strong>{nomeProjeto}</strong> requer senha para iniciar o deploy.
          </p>
          <form onSubmit={handleSubmit} autoComplete="off">
            <label style={S.label}>Senha</label>
            <input
              ref={inputRef}
              type="password"
              name="deploy_access_key"
              value={senha}
              onChange={(e) => { setSenha(e.target.value); }}
              onFocus={() => setInputLiberado(true)}
              style={{ ...S.input, ...(temErro ? S.inputErro : {}) }}
              placeholder="Digite a senha..."
              autoComplete="new-password"
              autoCorrect="off"
              autoCapitalize="none"
              spellCheck={false}
              readOnly={!inputLiberado}
            />
            {temErro && (
              <div style={S.mensagemErro}>
                <span>⚠</span>
                <span>{erroExterno}</span>
              </div>
            )}
            <div style={S.acoes}>
              <button type="button" style={S.btnCancelar} onClick={onCancelar}>
                Cancelar
              </button>
              <button
                type="submit"
                style={senha ? S.btnConfirmar : S.btnConfirmarDesabilitado}
                disabled={!senha}
              >
                Confirmar deploy
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

